import i18n from "i18next";

export const LANGUAGE_TO_DATE_LOCALE: Readonly<Record<string, string>> = {
  en: "en",
  es: "es",
  fr: "fr",
  ru: "ru",
  zh: "zh-cn",
};

export const getDateLocale = (language: string = i18n.language) =>
  LANGUAGE_TO_DATE_LOCALE[language] ?? "en";
